import type { Theme } from "@mui/material";
import { Box, Radio, Stack, Typography } from "@mui/material";
import type { WorkflowActivityChangeSet } from "../../../../../api/types/workflowTypes";
import WorkflowActivityChangeSetDiffTable from "./WorkflowActivityChangeSetDiffTable";
import { getChangeSetDisplayGroups } from "./workflowDetailsHelpers";

interface Props {
  changeSet: WorkflowActivityChangeSet;
  showSourceColumn?: boolean;
  isSelected: boolean;
  onSelectChangeSet?: () => void;
}

const selectableContainerStyle = (isSelected: boolean) => (t: Theme) => ({
  border: `1px solid ${isSelected ? t.palette.primary.main : t.palette.divider}`,
  borderRadius: t.spacing(1),
  pt: 1,
  pb: 2,
  px: 2,
});

const WorkflowActivityChangeSetSection = ({ showSourceColumn, changeSet, isSelected, onSelectChangeSet }: Props) => {
  const isSelectable = onSelectChangeSet !== undefined;
  const { ungroupedFields, sectionGroups } = getChangeSetDisplayGroups(changeSet.fields, changeSet.sections);

  return (
    <Box sx={isSelectable ? selectableContainerStyle(isSelected) : { pt: 1 }}>
      {(isSelectable || ungroupedFields.length > 0) && (
        <Stack direction="row" spacing={1} sx={{ pb: 1, alignItems: "center" }}>
          {isSelectable && <Radio checked={isSelected} onClick={() => !isSelected && onSelectChangeSet()} />}
          <Typography variant="subtitle2">{changeSet.name}</Typography>
        </Stack>
      )}
      {ungroupedFields.length > 0 && (
        <WorkflowActivityChangeSetDiffTable fields={ungroupedFields} showSourceColumn={showSourceColumn} />
      )}
      {sectionGroups.length > 0 && (
        <Stack spacing={4} sx={{ pt: ungroupedFields.length > 0 ? 4 : 0 }}>
          {sectionGroups.map((group) => (
            <Box key={group.name} sx={{ pt: 1 }}>
              <Typography variant="subtitle2" sx={{ pb: 1 }}>
                {group.name}
              </Typography>
              <WorkflowActivityChangeSetDiffTable fields={group.fields} showSourceColumn={showSourceColumn} />
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default WorkflowActivityChangeSetSection;
